import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import D3Component from './D3Component';
import DailyNutritionGraph from './DailyNutritionGraph';
import NutritionSettingContext from './NutritionSettingsContext';
import Stats from './Stats';
import './Dashboard.css';

function NutritionOverview(props) {
  const {
    mealThreshold,
    mealTimes,
    selectedMeal,
    selectedMealTime,
    selectMeal,
    selectMealTime,
    setMealThreshold,
  } = useContext(NutritionSettingContext);
  const { t } = useTranslation('dashboard');

  const {
    highlightDay,
    nutritionData = {},
  } = props;

  return (
    <Stats id="nutritionOverview" className="overview">
      <h2>{t('nutrition.overview.heading')}</h2>
      <svg width="100%" viewBox="0 0 721 351">
        <g transform="translate(0.5, 0.5)">
          <D3Component
            data={nutritionData}
            graph={DailyNutritionGraph}
            {...{
              highlightDay,
              mealTimes,
              mealThreshold,
              selectedMeal,
              selectedMealTime,
              setMealThreshold,
              selectMeal,
              selectMealTime,
            }}
          />
        </g>
      </svg>
    </Stats>
  );
}

export default NutritionOverview;
